import { useEffect, useState, useRef } from 'react'
import { getQueryObj } from '../../../../utils'
import { loginByToken } from '../../../../services/auth'
import { useDispatch, useSelector } from 'react-redux'
import './style.scss'
import { getEventDetailsAction } from '../../../../actions/event'
import { EVENTS_UI_CONFIG } from '../../../../data/event'
import useCounter from '../../../../hooks/useCounter'
import './css/98-layout.css'
import './css/classic-themes.min.css'
import './css/frontend.css'
import './css/print.css'
import './css/rs6.css'
import './css/style.css'
import './css/style.min.css'
import './css/wpcdt-public.css'
import './css/zn_dynamic.css'
import './css/znb_frontend.css'
import useBookNow from '../../useBookNow'
import { ROUTE } from '../../../../constants/route'
import { format } from 'date-fns'
import { parseDate } from '../../../../utils/date.util'
import { getEventDetails } from '../../../../services/viplava'

const isMayapur = () => {
    return window.location.href.includes(ROUTE.MAYAPYR2024?.path) ||
        window.location.href.includes(ROUTE.MAYAPUR2026?.path)
}

const isPuri = () => {
    return window.location.href.includes(ROUTE.PURI2024?.path)
}

const isBoth = () => {
    return window.location.href.includes(ROUTE.BOTHMNP?.path)
}

const getPlaceName = () => {
    if (isMayapur()) return ' Mayapur'
    if (isPuri()) return ' Puri'
    if (isBoth()) return ' Mayapur & Puri'
}

const getCurrentEvent = () => {
    // Get the current pathname from the URL
    const currentPath = window.location.pathname

    // Find the event by matching the shortLink property
    const event = EVENTS_UI_CONFIG.find(
        (config) => config.shortLink === currentPath
    )

    // Return the found event, or undefined if not found
    return event
}

// Activities for Mayapur/Puri camps
const activities = isMayapur() ? [
    {
        image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEhHB6w3fJqISlS9aKyiA26bRtrcEMCZw10hdFcyudt2pO_X7T0FZvEW7SX8FJMfBqr83nuDmxTqpNRUsLRTuoOCZF4cwc1OQxS-MolZYno3RhAAzVAoTC5Ah_K1Zdw1TCdNLlmD0PVgWBw0J8y7WiNAzT3fwE1zDhyRQs9so5OXPSuQzjq-pQ/w640-h426/337085623_698322295314447_407828882928341261_n.jpg',
        name: 'Spiritual Lectures',
        place: 'Navadvipa Mandal Parikrama',
    },
    {
        image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEif9ZtPj-PeB6s2wT0FbqdsBBQoMcwtsQFB901gS2IXV2LS3J_iVojQ8tkdDMjPYZtb3-wnqM8qnj0-e332zKRgNgo7Op-LOtFuRAOiHRtcDw3VAwvqFqRW6LRzoZ7HCdxvk4axB-VTGm0_szhE4h27a4XsCOqHxOOiz3sfSqOoBI8oZ7BkGw/w640-h426/337275172_967553604266496_5552959976965549214_n.jpg',
        name: 'Drama',
        place: 'Navadvipa Mandal Parikrama',
    },
    {
        image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg6HyJSR8Ce8K2mMaXXhHe67hmXYgtWMNmeaE6PgaaWj6ebdnJn4V3_KmkhB3erl_D1DzPFi0sOEJtQhHClPUT0m6bYevwEH0_rwR4L1xOvr8Zw-9iraGTTTMPsT4t-rjbgUrADObYJW_lZ0hpDRUU8v4y3mmPsS7OOLqy5z3DK5YD0RfPBVuZf/w640-h480/IMG_4870.jpg',
        name: 'Boating',
        place: 'Navadvipa Mandal Parikrama',
    },
    {
        image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEg2VdTgk15F5snDEEHJSmS1VHokdSkxfHG-40BEUtAtJo94r5kqV7ihu8lxihmTmV1oGUmt01dxFS0NyBBUx6vaoV3sskHr1snEWSrQgm4BYHLpfzPPEjK7kx1F5o3foQvsioHD1vHnsxu7eNuvfHF5Nln42HOMFaKg6gk23Nj5WL35V4u8lQ/w640-h426/336276182_188037300615741_6341922284717931736_n.jpg',
        name: 'Parikrama',
        place: 'Navadvipa Mandal Parikrama',
    },
    {
        image: 'https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEh2RuA4ZkHn0plvzpjs8nwMweTKeBwZYozWviYqqgAVp6hwELUKybvXrt6bZfIFWKsst2EOuiq0TjM7dB2MhLT-OhgyS1xGk2lc75_GH58MLtJqg5uNebnbbG3N-lfqiPWTTtjC-SbSGFw1HBNrJ02bUgAdMN6tVHhkj4cu6HJPYJ5-fT8HIQ/w640-h426/336790528_1109340713267355_8932175796651889278_n.jpg',
        name: 'Dhama Visit',
        place: 'Navadvipa Mandal Parikrama',
    },
] : [
    {
        image: isPuri()
            ? 'https://www.iskconbangalore.org/blog/wp-content/uploads/2015/07/sri-jagannatha-temple1.jpg'
            : 'https://cdn.tovp.org/wp-content/uploads/2013/01/tovp_drawing_slide-lg.jpg.webp',
        name: 'Temple Darshan',
        place: isPuri() ? 'Jagannath Puri' : 'Mayapur & Puri',
    },
    {
        image: 'http://4.bp.blogspot.com/-HFKxvjTuyuc/WnXFBOZc_9I/AAAAAAAAVxE/M5l9nOPNUfkXb4WcHNFHtBwe3PXqs7k2ACK4BGAYYCw/s1600/JMY_23%2BJan_JP%2B%25281073%2529.JPG',
        name: 'Kirtan Mela',
        place: isPuri() ? 'Jagannath Puri' : 'Mayapur & Puri',
    },
    {
        image: isPuri()
            ? 'https://res.cloudinary.com/dm1o3cvik/image/upload/v1733346364/mnpcamp2024/Tota-Gopinath-Temple-in-Puri-1024x576_fhog3c.png'
            : 'https://1.bp.blogspot.com/-kDBuR-641jQ/WnXG8l5bHNI/AAAAAAAAV6M/qJHvpHqR4oo0uW_uN4ZxsOXK6PKMPnUbgCK4BGAYYCw/s640/JMY_27%2BJan%2B%25281221%2529.JPG',
        name: 'Spiritual Lectures',
        place: isPuri() ? 'Jagannath Puri' : 'Mayapur & Puri',
    },
    {
        image: isBoth()
            ? 'https://www.iskconbangalore.org/blog/wp-content/uploads/2015/07/sri-jagannatha-temple1.jpg'
            : 'http://2.bp.blogspot.com/-GPU7R57Kwlw/WnXFCC-SmxI/AAAAAAAAVxs/bajOnA7qXmwyD_sRGT5fsBFXrk7KtSs6gCK4BGAYYCw/s1600/JMY_23%2BJan%2B%2528587%2529.JPG',
        name: 'Parikrama',
        place: isPuri() ? 'Jagannath Puri' : 'Mayapur & Puri',
    },
    {
        image: 'http://1.bp.blogspot.com/-d6EIgP2zy0s/WngvNheoo6I/AAAAAAAAV7U/qjCcM9LUxbEeZJXOFHQ9ce6ItxEhmjCHwCK4BGAYYCw/s1600/JMY_27%2BJan_%25281482%2529.JPG',
        name: 'Delicious Prasadam',
        place: isPuri() ? 'Jagannath Puri' : 'Mayapur & Puri',
    },
    {
        image: 'http://3.bp.blogspot.com/-xckZ5shZXf0/WnXGEUh6-FI/AAAAAAAAV1g/2jgJ3ZGrmiYc0XjANbB0IQRDXFIhCyX8gCK4BGAYYCw/s1600/JMY_25%2BJan%2B%2528884%2529.JPG',
        name: 'Spiritual Discussions',
        place: isPuri() ? 'Jagannath Puri' : 'Mayapur & Puri',
    },
]

const galleryImages = [
    {
        src: isPuri()
            ? 'https://www.iskconbangalore.org/blog/wp-content/uploads/2015/07/sri-jagannatha-temple1.jpg'
            : 'https://cdn.tovp.org/wp-content/uploads/2013/01/tovp_drawing_slide-lg.jpg.webp',
        alt: isPuri() ? 'Jagannath Puri Yatra' : isMayapur() ? 'Mayapur Yatra' : 'Mayapur & Puri Yatra',
        title: isPuri() ? 'Jagannath Puri Yatra' : isMayapur() ? 'Mayapur Yatra' : 'Mayapur & Puri Yatra',
    },
    {
        src: 'http://4.bp.blogspot.com/-HFKxvjTuyuc/WnXFBOZc_9I/AAAAAAAAVxE/M5l9nOPNUfkXb4WcHNFHtBwe3PXqs7k2ACK4BGAYYCw/s1600/JMY_23%2BJan_JP%2B%25281073%2529.JPG',
        alt: isPuri() ? 'Jagannath Puri Yatra' : isMayapur() ? 'Mayapur Yatra' : 'Mayapur & Puri Yatra',
        title: isPuri() ? 'Jagannath Puri Yatra' : isMayapur() ? 'Mayapur Yatra' : 'Mayapur & Puri Yatra',
    },
    {
        src: isPuri()
            ? 'https://res.cloudinary.com/dm1o3cvik/image/upload/v1733346364/mnpcamp2024/Tota-Gopinath-Temple-in-Puri-1024x576_fhog3c.png'
            : 'https://1.bp.blogspot.com/-kDBuR-641jQ/WnXG8l5bHNI/AAAAAAAAV6M/qJHvpHqR4oo0uW_uN4ZxsOXK6PKMPnUbgCK4BGAYYCw/s640/JMY_27%2BJan%2B%25281221%2529.JPG',
        alt: isPuri() ? 'Jagannath Puri Yatra' : isMayapur() ? 'Mayapur Yatra' : 'Mayapur & Puri Yatra',
        title: isPuri() ? 'Jagannath Puri Yatra' : isMayapur() ? 'Mayapur Yatra' : 'Mayapur & Puri Yatra',
    },
    {
        src: isBoth()
            ? 'https://www.iskconbangalore.org/blog/wp-content/uploads/2015/07/sri-jagannatha-temple1.jpg'
            : 'http://2.bp.blogspot.com/-GPU7R57Kwlw/WnXFCC-SmxI/AAAAAAAAVxs/bajOnA7qXmwyD_sRGT5fsBFXrk7KtSs6gCK4BGAYYCw/s1600/JMY_23%2BJan%2B%2528587%2529.JPG',
        alt: isPuri() ? 'Jagannath Puri Yatra' : isMayapur() ? 'Mayapur Yatra' : 'Mayapur & Puri Yatra',
        title: isPuri() ? 'Jagannath Puri Yatra' : isMayapur() ? 'Mayapur Yatra' : 'Mayapur & Puri Yatra',
    },
    {
        src: 'http://1.bp.blogspot.com/-d6EIgP2zy0s/WngvNheoo6I/AAAAAAAAV7U/qjCcM9LUxbEeZJXOFHQ9ce6ItxEhmjCHwCK4BGAYYCw/s1600/JMY_27%2BJan_%25281482%2529.JPG',
        alt: isPuri() ? 'Jagannath Puri Yatra' : isMayapur() ? 'Mayapur Yatra' : 'Mayapur & Puri Yatra',
        title: isPuri() ? 'Jagannath Puri Yatra' : isMayapur() ? 'Mayapur Yatra' : 'Mayapur & Puri Yatra',
    },
    {
        src: isPuri()
            ? 'https://www.iskconbangalore.org/blog/wp-content/uploads/2015/07/09.jpg'
            : 'http://1.bp.blogspot.com/-NGnznzOChG4/WnXFGi7PxhI/AAAAAAAAVzE/fqPSHmH2J6YOcQC4Xa8jJVHKFGtiHV_SACK4BGAYYCw/s1600/JMY_23%2BJan%2B%2528524%2529.JPG',
        alt: isPuri() ? 'Jagannath Puri Yatra' : isMayapur() ? 'Mayapur Yatra' : 'Mayapur & Puri Yatra',
        title: isPuri() ? 'Jagannath Puri Yatra' : isMayapur() ? 'Mayapur Yatra' : 'Mayapur & Puri Yatra',
    },
]

const CAMP_GALARY = []

const albums = isMayapur()
    ? [
        'https://www.facebook.com/media/set/?set=a.383171847812518&type=3',
        'https://www.facebook.com/media/set/?set=a.383189051144131&type=3',
        'https://www.facebook.com/media/set/?set=a.180816728048032&type=3',
        'https://www.facebook.com/media/set/?set=a.180907191372319&type=3',
        'https://www.facebook.com/media/set/?set=a.180922944704077&type=3',
    ]
    : [
        'https://www.facebook.com/media/set/?set=a.178487258280979&type=3',
        'https://www.facebook.com/media/set/?set=a.178945748235130&type=3',
        'https://www.facebook.com/media/set/?set=a.178981671564871&type=3',
        'https://www.facebook.com/media/set/?set=a.178981878231517&type=3',
    ]

const getBackgroundImage = () => {
    if (isMayapur()) {
        return 'https://tirthayatri.in/wp-content/uploads/2022/07/tovp-view-from-prabhupada-samadhi_1800x1013-1024x511.jpg'
    } else if (isPuri()) {
        return 'https://res.cloudinary.com/dm1o3cvik/image/upload/v1732914111/mnpcamp2024/jagannath-temple-in-puri-heritage_mcnqad.jpg'
    } else {
        return 'https://res.cloudinary.com/dm1o3cvik/image/upload/v1732649541/337118102_761122642038492_6626692394984210_n_hlxs0j.jpg'
    }
}

function formatSuperScript(input) {
    // Define a regex to match ordinal indicators (th, st, nd, rd) following a digit
    const ordinalRegex = /(?<=\d)(th|st|nd|rd)/g

    // Replace matches with their superscript equivalents wrapped in <sup> tags
    const convertedText = input.replace(
        ordinalRegex,
        (match) => `<sup>${match}</sup>`
    )

    return <span dangerouslySetInnerHTML={{ __html: convertedText }} />
}

const JagannathPuriMayapurCamp = ({ history, location, match }) => {
    const dispatch = useDispatch()

    const { handleRegisterBtnClick } = useBookNow()
    const eventFromUI = getCurrentEvent()

    // State for dynamic event details
    const [eventDetails, setEventDetails] = useState(null)
    const [loading, setLoading] = useState(true)
    const [isVisible, setIsVisible] = useState({})

    // Refs for animation triggers
    const heroRef = useRef(null)
    const countdownRef = useRef(null)
    const activitiesRef = useRef(null)
    const galleryRef = useRef(null)
    const detailsRef = useRef(null)

    const counter = useCounter(eventFromUI?.deadline)

    // Intersection Observer for scroll animations
    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(prev => ({ ...prev, [entry.target.id]: true }))
                    }
                })
            },
            { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
        )

        const elements = [heroRef.current, countdownRef.current, activitiesRef.current, galleryRef.current, detailsRef.current]
        elements.forEach(el => {
            if (el) observer.observe(el)
        })

        return () => observer.disconnect()
    }, [])

    useEffect(() => {
        const data = getQueryObj(location?.search)
        if (data.token) {
            loginByToken(data.token).then((res) => {
                const userProfile = res.data[0]
                userProfile.loggedIn = true
                localStorage.setItem('UserProfile', JSON.stringify(userProfile))
            })
        }
    }, [])

    // Fetch event details dynamically
    useEffect(() => {
        const fetchEventDetails = async () => {
            try {
                setLoading(true)
                const { result } = await getEventDetails()
                const event = result.find((event) => event.eventId === eventFromUI?.uuid)
                setEventDetails(event)
            } catch (error) {
                console.error('Error fetching event details:', error)
            } finally {
                setLoading(false)
            }
        }

        if (eventFromUI?.uuid) {
            fetchEventDetails()
        }
    }, [eventFromUI?.uuid])

    const events = useSelector((state) => state.eventReducer)?.events
    useEffect(() => {
        if (!events?.length) {
            dispatch(getEventDetailsAction())
        }
    }, [])

    if (!eventFromUI) {
        console.error('Event not found for current path:', window.location.pathname)
        return <div>Event not found</div>
    }

    return (
        <div>
            <div className="login_register_stuff" />
            {/* end login register stuff */} <div id="fb-root" />
            <div id="page_wrapper">
                <div
                    className="zn_pb_wrapper clearfix zn_sortable_content"
                    data-droplevel={0}
                >
                    {' '}
                    {/* Hero Section */}
                    <section
                        ref={heroRef}
                        id="hero"
                        className="hero-section relative min-h-screen flex items-center justify-center overflow-hidden"
                    >
                        {/* Background Image */}
                        <div
                            className="absolute inset-0 bg-cover bg-center bg-no-repeat bg-fixed animate-pulse"
                            style={{
                                backgroundImage: `url(${getBackgroundImage()})`,
                                backgroundAttachment: 'fixed',
                                backgroundSize: 'cover',
                                backgroundPosition: 'center center',
                                backgroundRepeat: 'no-repeat',
                                animation: 'fadeIn 2s ease-in-out'
                            }}
                        />
                        {/* Overlay */}
                        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/70 via-blue-900/70 to-indigo-900/70 animate-fadeIn" />

                        {/* Content */}
                        <div className="relative z-10 text-center text-white px-4 max-w-6xl mx-auto">
                            {/* Event Heading */}
                            <div className="mb-8">
                                {eventFromUI.heading ? (
                                    <>
                                        <h1
                                            className="text-5xl md:text-7xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500 animate-slideInUp"
                                            style={{
                                                animationDelay: '0.5s',
                                                animationFillMode: 'both'
                                            }}
                                        >
                                            {eventFromUI.heading.split(' ').slice(0, 1).join(' ').toUpperCase()}
                                        </h1>
                                        <h2
                                            className="text-4xl md:text-6xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500 animate-slideInUp"
                                            style={{
                                                animationDelay: '0.8s',
                                                animationFillMode: 'both'
                                            }}
                                        >
                                            {eventFromUI.heading.split(' ').slice(1).join(' ').toUpperCase()}
                                        </h2>
                                    </>
                                ) : (
                                    <h1
                                        className="text-5xl md:text-7xl font-bold mb-6 text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-orange-500 animate-slideInUp"
                                        style={{
                                            animationDelay: '0.5s',
                                            animationFillMode: 'both'
                                        }}
                                    >
                                        {isMayapur() ? 'ANNUAL MAYAPUR YATRA' : isPuri() ? 'JAGANNATH PURI YATRA' : 'ANNUAL YATRA'}
                                    </h1>
                                )}
                                <h3
                                    className="text-3xl md:text-5xl font-bold mb-8 text-white animate-slideInUp"
                                    style={{
                                        animationDelay: '1.1s',
                                        animationFillMode: 'both'
                                    }}
                                >
                                    {eventFromUI.title?.toUpperCase()}
                                </h3>
                                <div
                                    className="text-2xl md:text-3xl font-semibold mb-12 text-yellow-300 animate-slideInUp"
                                    style={{
                                        animationDelay: '1.4s',
                                        animationFillMode: 'both'
                                    }}
                                >
                                    {formatSuperScript(eventFromUI?.dates)}
                                </div>
                            </div>

                            {/* Registration Info */}
                            <div
                                className="mb-12 animate-slideInUp"
                                style={{
                                    animationDelay: '1.7s',
                                    animationFillMode: 'both'
                                }}
                            >
                                <p className="text-lg md:text-xl text-yellow-300 mb-4 font-medium tracking-wide">
                                    Registration will close on
                                </p>
                                <p className="text-xl md:text-2xl text-white font-bold">
                                    {format(parseDate(eventFromUI.deadline), 'MMMM do yyyy')}
                                </p>
                            </div>

                            {/* CTA Button */}
                            <div
                                className="mb-16 animate-slideInUp"
                                style={{
                                    animationDelay: '2s',
                                    animationFillMode: 'both'
                                }}
                            >
                                <button
                                    onClick={(...args) => handleRegisterBtnClick(eventFromUI, ...args)}
                                    className="bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-black font-bold text-xl px-12 py-4 rounded-full shadow-2xl transform hover:scale-110 transition-all duration-500 hover:shadow-yellow-500/50 animate-bounce-subtle"
                                >
                                    BOOK NOW
                                </button>
                            </div>
                        </div>
                    </section>
                    {/* Countdown Timer Section */}
                    <section
                        ref={countdownRef}
                        id="countdown"
                        className="countdown-section bg-gradient-to-r from-purple-900 to-indigo-900 py-8 md:py-12"
                    >
                        <div className="container mx-auto px-2 md:px-4">
                            <div className="text-center">
                                <h3
                                    className={`text-xl md:text-3xl font-bold text-white mb-6 md:mb-8 transition-all duration-1000 ${isVisible.countdown ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                        }`}
                                >
                                    DAYS REMAINING
                                </h3>
                                <div className="flex justify-center items-center gap-1 md:gap-8 max-w-4xl mx-auto overflow-x-auto">
                                    <div
                                        className={`bg-white/10 backdrop-blur-sm rounded-lg md:rounded-xl p-2 md:p-6 border border-white/20 min-w-[60px] md:min-w-[120px] flex-shrink-0 transition-all duration-1000 hover:scale-110 hover:bg-white/20 ${isVisible.countdown ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                            }`}
                                        style={{ animationDelay: '0.2s' }}
                                    >
                                        <div className="text-2xl md:text-4xl font-bold text-yellow-400 mb-1 animate-pulse">
                                            {counter?.days}
                                        </div>
                                        <div className="text-white/80 font-semibold text-xs md:text-sm uppercase tracking-wider">
                                            DAYS
                                        </div>
                                    </div>
                                    <div
                                        className={`text-yellow-400 text-xl md:text-3xl font-bold flex-shrink-0 transition-all duration-1000 ${isVisible.countdown ? 'animate-fadeIn opacity-100' : 'opacity-0'
                                            }`}
                                        style={{ animationDelay: '0.3s' }}
                                    >
                                        :
                                    </div>
                                    <div
                                        className={`bg-white/10 backdrop-blur-sm rounded-lg md:rounded-xl p-2 md:p-6 border border-white/20 min-w-[60px] md:min-w-[120px] flex-shrink-0 transition-all duration-1000 hover:scale-110 hover:bg-white/20 ${isVisible.countdown ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                            }`}
                                        style={{ animationDelay: '0.4s' }}
                                    >
                                        <div className="text-2xl md:text-4xl font-bold text-yellow-400 mb-1 animate-pulse">
                                            {counter?.hours}
                                        </div>
                                        <div className="text-white/80 font-semibold text-xs md:text-sm uppercase tracking-wider">
                                            HOURS
                                        </div>
                                    </div>
                                    <div
                                        className={`text-yellow-400 text-xl md:text-3xl font-bold flex-shrink-0 transition-all duration-1000 ${isVisible.countdown ? 'animate-fadeIn opacity-100' : 'opacity-0'
                                            }`}
                                        style={{ animationDelay: '0.5s' }}
                                    >
                                        :
                                    </div>
                                    <div
                                        className={`bg-white/10 backdrop-blur-sm rounded-lg md:rounded-xl p-2 md:p-6 border border-white/20 min-w-[60px] md:min-w-[120px] flex-shrink-0 transition-all duration-1000 hover:scale-110 hover:bg-white/20 ${isVisible.countdown ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                            }`}
                                        style={{ animationDelay: '0.6s' }}
                                    >
                                        <div className="text-2xl md:text-4xl font-bold text-yellow-400 mb-1 animate-pulse">
                                            {counter?.min}
                                        </div>
                                        <div className="text-white/80 font-semibold text-xs md:text-sm uppercase tracking-wider">
                                            MIN
                                        </div>
                                    </div>
                                    <div
                                        className={`text-yellow-400 text-xl md:text-3xl font-bold flex-shrink-0 transition-all duration-1000 ${isVisible.countdown ? 'animate-fadeIn opacity-100' : 'opacity-0'
                                            }`}
                                        style={{ animationDelay: '0.7s' }}
                                    >
                                        :
                                    </div>
                                    <div
                                        className={`bg-white/10 backdrop-blur-sm rounded-lg md:rounded-xl p-2 md:p-6 border border-white/20 min-w-[60px] md:min-w-[120px] flex-shrink-0 transition-all duration-1000 hover:scale-110 hover:bg-white/20 ${isVisible.countdown ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                            }`}
                                        style={{ animationDelay: '0.8s' }}
                                    >
                                        <div className="text-2xl md:text-4xl font-bold text-yellow-400 mb-1 animate-pulse">
                                            {counter?.sec}
                                        </div>
                                        <div className="text-white/80 font-semibold text-xs md:text-sm uppercase tracking-wider">
                                            SEC
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* Poster Image Section */}
                    {eventFromUI.posterImage && (
                        <div className="znColumnElement-innerWrapper-eluid45521b11 znColumnElement-innerWrapper znColumnElement-innerWrapper--valign-top znColumnElement-innerWrapper--halign-left ">
                            <div className="znColumnElement-innerContent">
                                {' '}
                                <div className="media-container eluidd816dbd6  media-container--type-btn kl-overlay-none  ">
                                    <div className="text-center flex justify-center w-100">
                                        <img
                                            src={eventFromUI.posterImage}
                                            className="self-center w-full max-w-4xl mx-auto"
                                            alt={eventFromUI.title || 'Event Poster'}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                    {/* Activities Gallery */}
                    <section
                        ref={activitiesRef}
                        id="activities"
                        className="activities-gallery bg-gradient-to-b from-white to-gray-50 py-16 md:py-24"
                    >
                        <div className="container mx-auto px-4">
                            {/* Section Header */}
                            <div className="text-center mb-12 md:mb-16">
                                <h2
                                    className={`text-4xl md:text-5xl font-bold mb-4 transition-all duration-1000 ${isVisible.activities ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                        }`}
                                >
                                    <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600">
                                        Activities
                                    </span>
                                </h2>
                                <p
                                    className={`text-lg text-gray-600 transition-all duration-1000 ${isVisible.activities ? 'animate-fadeIn opacity-100' : 'opacity-0'
                                        }`}
                                    style={{ animationDelay: '0.2s' }}
                                >
                                    {eventFromUI.title}
                                </p>
                            </div>

                            {/* Activities Grid */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
                                {activities?.map((activity, index) => (
                                    <div
                                        key={index}
                                        className={`group transition-all duration-1000 ${isVisible.activities ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                            }`}
                                        style={{ animationDelay: `${0.3 + (index * 0.1)}s` }}
                                    >
                                        <div className="relative h-72 md:h-80 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2">
                                            {/* Background Image */}
                                            <div
                                                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-110"
                                                style={{ backgroundImage: `url(${activity.image})` }}
                                            />

                                            {/* Gradient Overlay */}
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent group-hover:from-black/90 group-hover:via-black/50 transition-all duration-500" />

                                            {/* Content */}
                                            <div className="absolute bottom-0 left-0 right-0 p-6 text-white">
                                                <h3 className="text-2xl md:text-3xl font-bold mb-2 drop-shadow-lg">
                                                    {activity.name}
                                                </h3>
                                                <p className="text-base md:text-lg opacity-90 flex items-center">
                                                    <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                                    </svg>
                                                    {activity.place}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* Horizontal Gallery Section */}
                    <section
                        ref={galleryRef}
                        id="gallery"
                        className="gallery-section py-16 bg-gray-100"
                    >
                        <div className="container mx-auto px-4">
                            <h2
                                className={`text-3xl md:text-4xl font-bold text-center text-gray-800 mb-12 transition-all duration-1000 ${isVisible.gallery ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                    }`}
                            >
                                Event Gallery
                            </h2>
                            <div className="flex overflow-x-auto gap-6 pb-4 scrollbar-hide">
                                {galleryImages.map((image, index) => (
                                    <div
                                        key={index}
                                        className={`flex-shrink-0 transition-all duration-1000 ${isVisible.gallery ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                            }`}
                                        style={{ animationDelay: `${0.2 + (index * 0.1)}s` }}
                                    >
                                        <div className="relative group cursor-pointer">
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                title={image.title}
                                                className="w-80 h-64 object-cover rounded-lg shadow-lg transition-all duration-500 group-hover:scale-110 group-hover:shadow-2xl"
                                            />
                                            <div className="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-500 rounded-lg" />
                                            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent rounded-b-lg opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-4 group-hover:translate-y-0">
                                                <p className="text-white text-sm font-medium">{image.title}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                    {/* Event Details Section */}
                    <section
                        ref={detailsRef}
                        id="details"
                        className="zn_section eluidbbe439a1   zn_parallax  section-sidemargins    zn_section--relative section--no "
                    >
                        <div className="zn-bgSource zn-bgSource-imageParallax js-znParallax">
                            <div
                                className="zn-bgSource-image"
                                style={{
                                    backgroundImage: `url(${getBackgroundImage()})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center center',
                                    backgroundSize: 'cover',
                                }}
                            />
                            <div
                                className="zn-bgSource-overlay"
                                style={{
                                    backgroundColor: 'rgba(5,0,62,0.7)',
                                }}
                            />
                        </div>
                        <div className="zn_section_size container zn-section-height--auto zn-section-content_algn--top ">
                            <div className="row gutter-0">
                                <div
                                    className="eluid8147b945            col-md-12 col-sm-12   znColumnElement"
                                    id="eluid8147b945"
                                >
                                    <div className="znColumnElement-innerWrapper-eluid8147b945 znColumnElement-innerWrapper znColumnElement-innerWrapper--valign-top znColumnElement-innerWrapper--halign-left ">
                                        <div className="znColumnElement-innerContent">
                                            {' '}
                                            <h3
                                                className={`eluid3f9d1ca5  dn-heading transition-all duration-1000 ${isVisible.details ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                                    }`}
                                                id="eluid3f9d1ca5"
                                                itemProp="headline"
                                            >
                                                {formatSuperScript(eventFromUI?.dates)}
                                            </h3>
                                            <h3
                                                className={`eluideff4d654  dn-heading transition-all duration-1000 ${isVisible.details ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                                    }`}
                                                style={{ animationDelay: '0.2s' }}
                                                id="eluideff4d654"
                                                itemProp="headline"
                                            >
                                                {eventFromUI?.title}
                                            </h3>

                                            {/* Event Details Section */}
                                            {loading ? (
                                                <div
                                                    className={`loading-section transition-all duration-1000 ${isVisible.details ? 'animate-fadeIn opacity-100' : 'opacity-0'
                                                        }`}
                                                    style={{ marginTop: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '10px', textAlign: 'center' }}
                                                >
                                                    <p style={{ color: '#E6E6FA', fontSize: '18px' }}>Loading event details...</p>
                                                </div>
                                            ) : (
                                                <div
                                                    className={`event-details-section transition-all duration-1000 ${isVisible.details ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                                        }`}
                                                    style={{ marginTop: '30px', padding: '20px', backgroundColor: 'rgba(255,255,255,0.05)', borderRadius: '10px' }}
                                                >

                                                    {/* Pricing Information */}
                                                    <div
                                                        className={`pricing-info transition-all duration-1000 hover:bg-white/10 hover:scale-105 hover:shadow-lg ${isVisible.details ? 'animate-slideInLeft opacity-100' : 'opacity-0 -translate-x-8'
                                                            }`}
                                                        style={{ marginBottom: '25px', padding: '15px', borderRadius: '8px' }}
                                                    >
                                                        <h4 style={{ color: '#E6E6FA', fontSize: '20px', marginBottom: '15px' }}>
                                                            <strong>💰 Pricing Details</strong>
                                                        </h4>
                                                        <div style={{ fontSize: '16px', lineHeight: '1.6', color: '#F0F8FF' }}>
                                                            {(() => {
                                                                const transportMsg = eventDetails?.transportationMessage || eventFromUI.transportationMessage || '';
                                                                const withoutTransportMatch = transportMsg.match(/Without Transport[^:]*:\s*Rs?\.?\s*(\d+)/i);
                                                                const withTransportMatch = transportMsg.match(/With Transport[^:]*:\s*Rs?\.?\s*(\d+)/i);

                                                                const withoutPrice = withoutTransportMatch ? withoutTransportMatch[1] : (eventDetails?.registrationAmount || eventFromUI.startingPrice);
                                                                const withPrice = withTransportMatch ? withTransportMatch[1] : null;

                                                                return (
                                                                    <>
                                                                        <p className="hover:text-yellow-300 transition-colors duration-300">
                                                                            <strong>Without Transportation:</strong> ₹{withoutPrice}/-
                                                                        </p>
                                                                        {withPrice && (
                                                                            <p className="hover:text-yellow-300 transition-colors duration-300">
                                                                                <strong>With Transportation:</strong> ₹{withPrice}/-
                                                                            </p>
                                                                        )}
                                                                    </>
                                                                );
                                                            })()}
                                                        </div>
                                                    </div>

                                                    {/* Accommodation Details */}
                                                    {(eventDetails?.accomodationCategory || eventFromUI.accomodationCategory) && (eventDetails?.accomodationCategory || eventFromUI.accomodationCategory).length > 0 && (
                                                        <div
                                                            className={`accommodation-info transition-all duration-1000 hover:bg-white/10 hover:scale-105 hover:shadow-lg ${isVisible.details ? 'animate-slideInRight opacity-100' : 'opacity-0 translate-x-8'
                                                                }`}
                                                            style={{ marginBottom: '25px', padding: '15px', borderRadius: '8px' }}
                                                        >
                                                            <h4 style={{ color: '#E6E6FA', fontSize: '20px', marginBottom: '15px' }}>
                                                                <strong>🏠 Accommodation Options</strong>
                                                            </h4>
                                                            <div style={{ fontSize: '16px', lineHeight: '1.6', color: '#F0F8FF' }}>
                                                                {(eventDetails?.accomodationCategory || eventFromUI.accomodationCategory).map((accommodation, index) => (
                                                                    <p key={index} className="hover:text-yellow-300 transition-colors duration-300">
                                                                        <strong>{accommodation.name}:</strong> ₹{accommodation.price}/-
                                                                    </p>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* Eligibility Requirements */}
                                                    {(eventDetails?.criteriaPoint || eventFromUI?.criteriaPoint) && (
                                                        <div className="eligibility-info" style={{ marginBottom: '25px' }}>
                                                            <h4 style={{ color: '#E6E6FA', fontSize: '20px', marginBottom: '15px' }}>
                                                                <strong>✅ Eligibility Requirements</strong>
                                                            </h4>
                                                            <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#F0F8FF' }}>
                                                                {eventDetails?.criteriaPoint || eventFromUI.criteriaPoint}
                                                            </p>
                                                            {(eventDetails?.eligibility?.minimumChantingRounds || eventFromUI.eligibility?.minimumChantingRounds) && (
                                                                <p style={{ fontSize: '16px', lineHeight: '1.6', marginTop: '10px', color: '#F0F8FF' }}>
                                                                    <strong>Minimum Chanting Rounds:</strong> {eventDetails?.eligibility?.minimumChantingRounds || eventFromUI.eligibility.minimumChantingRounds} rounds per day
                                                                </p>
                                                            )}
                                                        </div>
                                                    )}

                                                    {/* Recommendations */}
                                                    {(eventDetails?.recommendation || eventFromUI?.recommendation) && (
                                                        <div className="recommendation-info" style={{ marginBottom: '25px' }}>
                                                            <h4 style={{ color: '#E6E6FA', fontSize: '20px', marginBottom: '15px' }}>
                                                                <strong>💡 Recommendations</strong>
                                                            </h4>
                                                            <p style={{ fontSize: '16px', lineHeight: '1.6', color: '#F0F8FF' }}>
                                                                {eventDetails?.recommendation || eventFromUI.recommendation}
                                                            </p>
                                                        </div>
                                                    )}

                                                    {/* Payment Information */}
                                                    <div className="payment-info" style={{ marginBottom: '25px' }}>
                                                        <h4 style={{ color: '#E6E6FA', fontSize: '20px', marginBottom: '15px' }}>
                                                            <strong>💳 Payment Options</strong>
                                                        </h4>
                                                        <div style={{ fontSize: '16px', lineHeight: '1.6', color: '#F0F8FF' }}>
                                                            {(eventDetails?.allowOnlinePayment || eventFromUI.allowOnlinePayment) && <p>✅ Online Payment Available</p>}
                                                            {(eventDetails?.allowCash || eventFromUI.allowCash) && <p>✅ Cash Payment Accepted</p>}
                                                        </div>
                                                    </div>

                                                    {/* Important Notes */}
                                                    <div className="important-notes" style={{ marginBottom: '25px' }}>
                                                        <h4 style={{ color: '#E6E6FA', fontSize: '20px', marginBottom: '15px' }}>
                                                            <strong>📋 Important Information</strong>
                                                        </h4>
                                                        <div style={{ fontSize: '16px', lineHeight: '1.6', color: '#F0F8FF' }}>
                                                            <p><strong>Registration Deadline:</strong> {format(parseDate(eventDetails?.deadline || eventFromUI.deadline), 'MMMM do yyyy')}</p>
                                                            {(eventDetails?.paymentLastDate || eventFromUI.paymentLastDate) && (
                                                                <p><strong>Payment Last Date:</strong> {format(parseDate(eventDetails?.paymentLastDate || eventFromUI.paymentLastDate), 'MMMM do yyyy')}</p>
                                                            )}
                                                            {(eventDetails?.nonRefundableMessage || eventFromUI.nonRefundableMessage) && (
                                                                <p style={{ color: '#FFB6C1' }}><strong>⚠️ {eventDetails?.nonRefundableMessage || eventFromUI.nonRefundableMessage}</strong></p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            )}

                                            <div
                                                id="eluidbda8a035"
                                                className={`zn_buttons_element eluidbda8a035 text-center mt-6 transition-all duration-1000 ${isVisible.details ? 'animate-slideInUp opacity-100' : 'opacity-0 translate-y-8'
                                                    }`}
                                                style={{ animationDelay: '0.8s' }}
                                            >
                                                <a
                                                    href="#"
                                                    id="eluidbda8a0350"
                                                    className="eluidbda8a0350 btn-element btn-element-0 btn  btn-fullcolor btn-custom-color   zn_dummy_value btn-icon--before btn--square hover:scale-110 hover:shadow-2xl transition-all duration-500"
                                                    target="_self"
                                                    itemProp="url"
                                                    onClick={(...args) =>
                                                        handleRegisterBtnClick(
                                                            eventFromUI,
                                                            ...args
                                                        )
                                                    }
                                                >
                                                    <span>BOOK NOW</span>
                                                </a>
                                            </div>{' '}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div className="clearfix" />
                </div>{' '}
                {/* Enhanced Footer */}
                <footer
                    id="footer"
                    className="site-footer bg-gradient-to-r from-purple-900 via-indigo-900 to-blue-900 text-white relative overflow-hidden"
                    role="contentinfo"
                    itemScope="itemscope"
                    itemType="https://schema.org/WPFooter"
                >
                    {/* Background Pattern */}
                    <div className="absolute inset-0 opacity-10">
                        <div className="absolute inset-0" style={{
                            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='2'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
                            backgroundSize: '60px 60px'
                        }} />
                    </div>

                    <div className="container mx-auto px-4 py-16 relative z-10">
                        {/* Main Footer Content */}
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
                            {/* Event Information */}
                            <div className="animate-slideInUp" style={{ animationDelay: '0.1s' }}>
                                <h3 className="text-2xl font-bold text-yellow-400 mb-6">{eventFromUI.heading || eventFromUI.title}</h3>
                                <p className="text-gray-300 mb-4 leading-relaxed">
                                    {isMayapur()
                                        ? 'Join us for a transformative spiritual journey in the sacred land of Navadvipa. Experience divine bliss through parikrama, lectures, and temple darshan.'
                                        : isPuri()
                                            ? 'Join us for a transformative spiritual journey in the sacred land of Jagannath Puri. Experience divine bliss through parikrama, lectures, and temple darshan.'
                                            : 'Join us for a transformative spiritual journey in the sacred lands of Mayapur and Jagannath Puri. Experience divine bliss through parikrama, lectures, and temple darshan.'}
                                </p>
                                <div className="flex items-center text-yellow-300">
                                    <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                                    </svg>
                                    <span>{isMayapur() ? 'Navadvipa, Mayapur' : isPuri() ? 'Jagannath Puri' : 'Mayapur & Puri'}</span>
                                </div>
                            </div>

                            {/* Quick Links */}
                            <div className="animate-slideInUp" style={{ animationDelay: '0.2s' }}>
                                <h4 className="text-xl font-semibold text-white mb-6">Quick Links</h4>
                                <ul className="space-y-3">
                                    <li>
                                        <a
                                            href="#hero"
                                            className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 flex items-center group"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                document.getElementById('hero')?.scrollIntoView({ behavior: 'smooth' });
                                            }}
                                        >
                                            <svg className="w-4 h-4 mr-2 group-hover:translate-x-1 transition-transform duration-300" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                            </svg>
                                            About Event
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#activities"
                                            className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 flex items-center group"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                document.getElementById('activities')?.scrollIntoView({ behavior: 'smooth' });
                                            }}
                                        >
                                            <svg className="w-4 h-4 mr-2 group-hover:translate-x-1 transition-transform duration-300" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                            </svg>
                                            Activities
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#gallery"
                                            className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 flex items-center group"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                document.getElementById('gallery')?.scrollIntoView({ behavior: 'smooth' });
                                            }}
                                        >
                                            <svg className="w-4 h-4 mr-2 group-hover:translate-x-1 transition-transform duration-300" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                            </svg>
                                            Gallery
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="#details"
                                            className="text-gray-300 hover:text-yellow-400 transition-colors duration-300 flex items-center group"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                document.getElementById('details')?.scrollIntoView({ behavior: 'smooth' });
                                            }}
                                        >
                                            <svg className="w-4 h-4 mr-2 group-hover:translate-x-1 transition-transform duration-300" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                            </svg>
                                            Event Details
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            {/* Event Schedule */}
                            <div className="animate-slideInUp" style={{ animationDelay: '0.3s' }}>
                                <h4 className="text-xl font-semibold text-white mb-6">Event Schedule</h4>
                                <div className="space-y-4">
                                    <div className="flex items-start">
                                        <div className="w-3 h-3 bg-yellow-400 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <div>
                                            <p className="text-white font-medium">{eventFromUI?.dates?.split(' - ')[0] || 'Event Begins'}</p>
                                            <p className="text-gray-300 text-sm">Event Begins</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start">
                                        <div className="w-3 h-3 bg-yellow-400 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <div>
                                            <p className="text-white font-medium">{eventFromUI?.dates?.split(' - ')[1] || 'Event Concludes'}</p>
                                            <p className="text-gray-300 text-sm">Event Concludes</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start">
                                        <div className="w-3 h-3 bg-yellow-400 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                                        <div>
                                            <p className="text-white font-medium">Daily Program</p>
                                            <p className="text-gray-300 text-sm">{isMayapur() ? 'Parikrama, Lectures & Dhama Visit' : 'Mangala Aarti to Evening Kirtan'}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Contact & Registration */}
                            <div className="animate-slideInUp" style={{ animationDelay: '0.4s' }}>
                                <h4 className="text-xl font-semibold text-white mb-6">Get In Touch</h4>
                                <div className="space-y-4">
                                    <div className="flex items-center text-gray-300">
                                        <svg className="w-5 h-5 mr-3 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                            <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                                        </svg>
                                        <span>info@coastok.com</span>
                                    </div>
                                    <div className="flex items-center text-gray-300">
                                        <svg className="w-5 h-5 mr-3 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                                            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                                        </svg>
                                        <span>+91-XXXXXXXXXX</span>
                                    </div>
                                    <button
                                        onClick={(...args) => handleRegisterBtnClick(eventFromUI, ...args)}
                                        className="w-full bg-gradient-to-r from-yellow-400 to-orange-500 hover:from-yellow-500 hover:to-orange-600 text-black font-bold py-3 px-6 rounded-full transition-all duration-300 hover:scale-105 hover:shadow-lg mt-4"
                                    >
                                        Register Now
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Footer Bottom */}
                        <div className="border-t border-gray-700 pt-8">
                            <div className="flex flex-col md:flex-row justify-between items-center">
                                {/* Copyright */}
                                <div className="animate-fadeIn mb-4 md:mb-0">
                                    <p className="text-gray-300 text-center md:text-left">
                                        © 2026 {eventFromUI.heading || eventFromUI.title}. All rights reserved. Powered by{' '}
                                        <a
                                            href="https://coastok.com"
                                            className="text-yellow-400 hover:text-yellow-300 transition-colors duration-300 font-semibold"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            COASTOK
                                        </a>
                                    </p>
                                </div>

                                {/* Social Links */}
                                <div className="animate-fadeIn flex space-x-4">
                                    <a
                                        href="#"
                                        className="w-10 h-10 bg-gray-700 hover:bg-yellow-400 text-white hover:text-black rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                                        aria-label="Facebook"
                                    >
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                        </svg>
                                    </a>
                                    <a
                                        href="#"
                                        className="w-10 h-10 bg-gray-700 hover:bg-yellow-400 text-white hover:text-black rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                                        aria-label="Instagram"
                                    >
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987 6.62 0 11.987-5.367 11.987-11.987C24.014 5.367 18.637.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.323-1.297C4.198 14.895 3.708 13.744 3.708 12.447s.49-2.448 1.297-3.323c.875-.807 2.026-1.297 3.323-1.297s2.448.49 3.323 1.297c.807.875 1.297 2.026 1.297 3.323s-.49 2.448-1.297 3.323c-.875.807-2.026 1.297-3.323 1.297zm7.83-9.281c-.49 0-.875-.385-.875-.875s.385-.875.875-.875.875.385.875.875-.385.875-.875.875z" />
                                        </svg>
                                    </a>
                                    <a
                                        href="#"
                                        className="w-10 h-10 bg-gray-700 hover:bg-yellow-400 text-white hover:text-black rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                                        aria-label="Twitter"
                                    >
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" />
                                        </svg>
                                    </a>
                                    <a
                                        href="#"
                                        className="w-10 h-10 bg-gray-700 hover:bg-yellow-400 text-white hover:text-black rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                                        aria-label="YouTube"
                                    >
                                        <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                                        </svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Decorative Elements */}
                    <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-400 via-orange-500 to-yellow-400"></div>
                </footer>
            </div>
            {/* end page_wrapper */}
        </div>
    )
}

export default JagannathPuriMayapurCamp